import docReady from './Functions/docReady';
import MapNew from './Functions/initMap';
import { buildVisiblePrice } from './Functions/buildVisiblePrice.js'
import tippy, { followCursor } from 'tippy.js';

docReady(function () {
    let printJobsVue = new Vue({
        el: '.pic-under-navbar',
        data: function () {
            return {
                recentPrintJobs: model.recentPrintJobs ?? [],
                singleStep: model.singleStep ?? false,
                interval: undefined,
                showMapModal: false,
                showEmailDialog: false,
                showPriceDialog: false,
                currentPreview: null,
                showPreviewDialog: false,
                showPinDialog: false,
                picpin: model.picpin
            }
        },
        mounted: function () {
            this.updateFileStatuses();
            this.interval = setInterval(() => {
                this.updateFileStatuses();
            }, 3000);
        },
        computed: {
            activeJobs: function (){
                return this.recentPrintJobs.filter(x => !x.isError && !x.isCancelled && !x.isPickedUp && !x.isInProgress);
            },
            minPrice: function () {
                return this.activeJobs.reduce((total, obj) => obj.priceRange.minPrice + total, 0)
            },
            maxPrice: function () {
                return this.activeJobs.reduce((total, obj) => obj.priceRange.maxPrice + total, 0)
            },
            totalPrices: function () {
                // Flatten all locationPrices into a single array
                const allPrices = this.activeJobs.flatMap(x => x.priceRange.locationPrices);

                // Group by location and sum prices
                const grouped = [];
                allPrices.forEach(({ id, location, price }) => {
                    var existingItem = grouped.find((item) => item.id === id);
                    if (!existingItem) {
                        grouped.push({ id, location, price, formattedPrice: 0 });
                    } else {
                        existingItem.price += price;
                    }
                });
                grouped.forEach(item => {
                    item.formattedPrice = buildVisiblePrice(item.price, model.currencyInfo, 2, 4);
                });

                grouped.sort((a, b) => a.location.localeCompare(b.location));

                // Get array of summed prices
                const priceArray = grouped.map(item => item.price);

                // Calculate highest and lowest price
                let highestPrice = priceArray.length ? Math.max(...priceArray) : 0;
                let lowestPrice = priceArray.length ? Math.min(...priceArray) : 0;
                let totalPrice = buildVisiblePrice(this.minPrice, model.currencyInfo, 2, 4);

                // Format highest and lowest price
                lowestPrice = buildVisiblePrice(lowestPrice, model.currencyInfo, 2, 4);
                highestPrice = buildVisiblePrice(highestPrice, model.currencyInfo, 2, 4);
                // Optionally, attach to result
                return {
                    grouped,
                    highestPrice,
                    lowestPrice,
                    totalPrice
                };

                //return grouped;
            },
            canPrintEverywhere: function () {
                if (model.singleStep) {
                    return appMain.currentBudget.budget >= this.maxPrice || !this.maxPrice
                } else {
                    return true;
                }
            }
        },
        methods: {
            openPreview: function (preview) {
                this.currentPreview = preview;
                this.showPreviewDialog = true
            },
            sendPinToEmail: function () {
                axios.post('/api/v1.0/me/sendPicPinToEmail')
                    .then(function (response) {
                        appMain.notifications = [{ type: 'success', message: response.data.message }];
                    })
                    .catch(function (err) {
                        appMain.notifications = [{ type: 'error', message: model.localization.Pages_Account_PiCPINToEmailFailed }];
                    });
            },
            cancelJob: function (jobId) {
                var job = this.recentPrintJobs.find(x => x.id == jobId);
                job.isInProgress = false;
                job.isError = false;
                job.isPickedUp = false;
                job.isCancelled = true;
            },
            toggleMap: function (selectedPrintPointName) {
                if (!model.singleStep && this.recentPrintJobs.length) {
                    selectedPrintPointName = this.recentPrintJobs[0].partnerID;
                }
                if (!map) {
                    map = new MapNew(selectedPrintPointName);
                } else {
                    map.changePrintPoint(selectedPrintPointName);
                }
                this.showMapModal = !this.showMapModal;
            },
            togglePin: function () {
                this.showPinDialog = !this.showPinDialog;
            },
            generatePin: function () {
                axios.put('/api/v1.0/me/securitytokens/PiCPIN', {
                    value: ''
                })
                    .then(function (response) {
                        if (response.status === 200) {
                            this.picpin = response.data.value;
                        }
                    }.bind(this))
                    .catch(function (err) {
                        appMain.notifications = [{ type: 'error', message: err.response.data }];
                    }.bind(this));
            },
            updateFileStatuses: function () {
                var inProgressJobIds = [];
                this.recentPrintJobs.filter(function (e) {
                    return e.isInProgress;
                }).forEach(element => inProgressJobIds.push(element.id));
                if (inProgressJobIds.length === 0) {
                    return;
                }
                axios.get('/api/v1.0/printjobs/status?id=' + inProgressJobIds.join('&id='), {
                    id: inProgressJobIds
                })
                    .then(function (response) {
                        response.data.forEach(responseElement => {
                            var vueElement = this.recentPrintJobs.find(e => e.id == responseElement.id);
                            vueElement.isCancelled = responseElement.isCancelled;
                            vueElement.isError = responseElement.isError;
                            vueElement.isInProgress = responseElement.isInProgress;
                            vueElement.statusString = responseElement.status;
                        });
                    }.bind(this))
                    .catch(function (error) {
                        console.log(error);
                    })
            }
        }
    })
});

Vue.component('delete-modal', {
    template: '#confirm-delete-template',
    methods: {
        closeModal: function () {
            this.$emit('close-modal');
        },
        confirmDelete: function () {
            this.$emit('delete');
        }
    }
});
Vue.component('preview-modal', {
    template: '#preview-modal-template',
    methods: {
        closeModal: function () {
            this.currentPage = 1;
            this.$emit('close-modal');
        },
        nextPage: function (add = false) {
            this.loaded = false;
            if (add) {
                if (this.data.pages >= (this.currentPage + 1)) {
                    this.currentPage++;
                }
            } else {
                if (this.currentPage > 1) {
                    this.currentPage--;
                }
            }
        },
        previewUrl: function (getOriginalImage = false, width = null) {
            var originalUrl = '/api/v1.0/files/' + this.data.id + '/pagePreview/' + this.currentPage + '/1/' + this.data.settings.isA3;
            if (width) {
                originalUrl += '?w=' + width;
            }
            return originalUrl;
        },
        previewSrcSet: function () {
            return this.previewUrl(false, 200) + ' 1x, ' + this.previewUrl(false, 400) + ' 2x, ' + this.previewUrl(false, 600) + ' 3x';
        },
        focusPreviewImage: function () {
            this.loaded = true;
        }
    },
    watch: {
        data: function (val, oldval) {
            if (oldval && val.id !== oldval.id) {
                this.loaded = false;
            }
        },
    },
    props: ['data'],
    data: function () {
        return {
            currentPage: 1,
            loaded: false
        }
    },
});
Vue.component('price-modal', {
    template: '#price-modal-template',
    methods: {
        closeModal: function () {
            this.$emit('close-modal');
        }
    },
    props: ['data']
});
Vue.component('send-code-to-email', {
    template: '#send-code-to-email-template',
    methods: {
        closeModal: function () {
            this.$emit('close-modal');
        },
        sendCode: function () {
            let email = document.getElementById('jobCodeEmail').value;
            axios.post('/api/v1.0/me/sendJobCodeToEmail', { email: email })
                .then(function (response) {
                    appMain.notifications = [{ type: 'success', message: response.data.message }];
                })
                .catch(function (err) {
                    appMain.notifications = [{ type: 'error', message: err.response.data }];
                });
            this.$emit('close-modal');
        }
    }
})

let map;
var currentTimeZone = Intl.DateTimeFormat().resolvedOptions();
Vue.component('print-job', {
    data: function () {
        return {
            maxLife: 48,
            currencyInfo: model.currencyInfo,
            updating: false,
            pricesOpen: false,
            singleStep: model.singleStep
        }
    },
    props: {
        id: Number,
        serverId: String,
        itemName: String,
        settings: Object,
        isError: Boolean,
        isInProgress: Boolean,
        isCancelled: Boolean,
        isPickedUp: Boolean,
        internalId: String,
        ageInHours: Number,
        status: String,
        priceRange: Object,
        price: Number,
        index: Number,
        pageCount: Number
    },
    emits: ['toggle-map', 'open-preview'],
    template: '#active-job-template',
    methods: {
        openPreview: function (id, pageCount, settings) {
            this.$emit('open-preview', { id: id, pages: pageCount, settings: settings });
        },
        toggleMap: function (name) {
            if (this.isWaitingForPickup) {
                if (model.singleStep) {
                    this.$emit('toggle-map');
                } else {
                    this.$emit('toggle-map', this.serverId);
                }
            }
        },
        openConfirm: function () {
            this.updating = true;
        },
        cancelPrintJob: function () {
            axios.delete('/api/v1.0/printjobs/' + this.id)
                .then(function (response) {
                    this.$emit('cancel', this.id);
                    this.updating = false;
                }.bind(this))
                .catch(function (error) {
                    console.log(error);
                })
        }
    },

    mounted: function () {
        if (model.singleStep) {
            tippy('.activePrintJob:nth-of-type(' + (this.index + 1) + ') .bottom div span.hoverHelpItem', {
                followCursor: 'horizontal',
                plugins: [followCursor],
                maxWidth: 'none'
            });
            this.priceRange.locationPrices = this.priceRange.locationPrices.sort((a, b) => (a.price > b.price) ? 1 : ((b.price > a.price) ? -1 : 0));

            this.priceRange.locationPrices.forEach(element => {
                element.formattedPrice = buildVisiblePrice(element.price, model.currencyInfo, 2, 4);
            });
        }
    },
    computed: {
        pages: function () {
            if (this.pageCount > 1) {
                return this.pageCount + ' ' + model.localization.Pages_Print_PagesAbbr_JS;
            } else {
                return this.pageCount + ' ' + model.localization.Pages_Print_PageAbbr_JS;
            }
        },
        copies: function () {
            if (this.settings.copyCount > 1) {
                return ' x ' + this.settings.copyCount + ' ' + model.localization.Pages_Print_CopiesAbbr_JS;
            }
            return '';
        },
        isJobCancelled: function () {
            return this.isCancelled;
        },
        isWaitingForPickup: function () {
            return !this.isError && !this.isCancelled && !this.isPickedUp && !this.isInProgress
        },
        deviceList: function () {
            var partner = model.devices.find(x => x.id === this.serverId);
            var availableDevices = partner.devices.filter(x => (x.hasColor || !this.settings.isColor) && (x.hasDuplex || !this.settings.isDuplex) && (x.hasA3 || !this.settings.isA3));
            if (availableDevices != undefined) {
                return availableDevices;
            } else {
                return [];
            }

        },
        priceRangeText: function () {
            if (model.singleStep) {
                // Hinnavahemik MEAP
                if (this.priceRange.minPrice != this.priceRange.maxPrice) {
                    return buildVisiblePrice(this.priceRange.minPrice, model.currencyInfo, 2, 4) + ' – ' + buildVisiblePrice(this.priceRange.maxPrice, model.currencyInfo, 2, 4);
                } else {
                    return buildVisiblePrice(this.priceRange.maxPrice, model.currencyInfo, 2, 4)
                }

            } else {
                if (this.price == -1) {
                    // Unlimited
                    return ''
                } else {
                    // Kindel prindipunkt
                    return buildVisiblePrice(this.price, model.currencyInfo, 2, 4);
                }
            }
        },
        statusString: function () {
            if (this.isWaitingForPickup) {
                if ((this.maxLife - this.ageInHours) < 13 && (this.maxLife - this.ageInHours)) {
                    return model.localization.Pages_Jobs_JobReady_JS.format(this.maxLife - this.ageInHours);
                }
            }
            //else if (this.isPickedUp) {
            //    return model.localization.Pages_Jobs_JobPickedUp_JS;
            //}
            //else if (this.isCancelled) {
            //    return model.localization.Pages_Jobs_JobCancelled_JS;
            //}
            else if (this.isError) {
                return model.localization.Pages_Jobs_UnknownError_JS;
            } else if (this.isInProgress) {
                return this.status;
            }
            return null;
        },
        dateString: function () {
            var dateObj = new Date(Date.now() - (this.ageInHours * 3600000)).toLocaleString(currentLanguageCode, {
                timeZone: currentTimeZone.timeZone,
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric" });
            return dateObj;

        }
    }
})
